/** Fixed-point conventions shared by content and sim (SPEC §3). */

/** Simulation ticks per second. */
export const TICK_HZ = 12;
/** One hex in fixed units (thousandths of a hex). */
export const HEX = 1000;
/** Basis points: 10000 = 100 %. */
export const BP = 10000;

/** Seconds → ticks. Only for authoring content with integer seconds. */
export const sec = (s: number): number => s * TICK_HZ;
/** Minutes → milliseconds (real time, campaign layer). */
export const minutesMs = (m: number): number => m * 60_000;
export const hoursMs = (h: number): number => h * 3_600_000;
export const daysMs = (d: number): number => d * 86_400_000;
